// bootstrap component
import { Button as BsButton, Spinner } from 'react-bootstrap'

// styles
import classes from './styles.module.scss'

// utils
import type { ButtonsEnum } from '@centria-ui/commons/enums'

// types
import type { ButtonProps as BsButtonProps } from 'react-bootstrap/Button'
import type { FC } from 'react'

export interface ButtonProps extends BsButtonProps {
  loading?: boolean
  variant?: keyof typeof ButtonsEnum
}

export const Button: FC<ButtonProps> = ({
  loading,
  children,
  className = '',
  variant = 'primary',
  ...props
}) => (
  <BsButton
    {...props}
    disabled={props.disabled || loading}
    className={`${className} ${classes[`button_${variant}`]}`}>
    {loading ? <Spinner size='sm' animation='grow' /> : children}
  </BsButton>
)
